import { css } from '@emotion/react'

const styles = () => {
    return {
        dialogContentRoot: css` align-items: stretch `,
        contextContainer: css` height: 475px `,
        contextButton: css` margin: 10px 25px 10px 25px `,
    }
}

export default styles
